"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = destructure;
var RESERVED_KEYWORDS = ['memoize', 'allIds', 'byId', 'length'];

function destructure(structure, method) {
  var result = Object.keys(structure).reduce(function (res, key) {
    if (process.env.NODE_ENV === 'development') {
      if (RESERVED_KEYWORDS.includes(key)) throw new Error("".concat(key, " used in the redux structure is a reserved keyword"));
    }

    res[key] = method(structure[key], key);
    return res;
  }, {});
  return result;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@sharingapples/redux/dist/destructure.js
// module id = 595
// module chunks = 2